const zhCN = {
  common: {
    appName: 'HiBro 开发者平台',
    save: '保存',
    cancel: '取消',
    confirm: '确认',
    copy: '复制',
    copied: '已复制',
    edit: '编辑',
    reset: '重置',
    delete: '删除',
    back: '返回',
    loading: '加载中…',
    empty: '暂无数据',
    show: '显示',
    hide: '隐藏',
    enabled: '已启用',
    disabled: '未启用',
    createdAt: '创建时间',
    cropTitle: '裁剪图片',
    cropZoom: '缩放',
    cropFailed: '裁剪失败，请重试',
    preview: '预览',
    download: '下载',
  },
  lang: {
    label: '语言',
    'zh-CN': '简体中文',
    'en-US': 'English',
  },
  spaceSwitcher: {
    label: '切换空间',
    placeholder: '选择空间',
    personal: '空间管理',
    workspace: '工作空间',
    role: {
      owner: '拥有者',
      admin: '管理员',
      member: '成员',
    },
    logout: '登出',
  },
  env: {
    current: '当前环境',
  },
  nav: {
    workbench: '工作台',
    accountSettings: '账号设置',
    developerInfo: '开发者信息',
    sdkDownload: 'SDK 下载',
  },
  appNav: {
    groupAppSettings: '应用设置',
    groupVersion: '版本管理',
    groupDev: '开发设置',
    dashboard: 'Dashboard',
    backToHome: '返回主页',
    allVersions: '所有版本',
    newVersion: '新建版本',
    appId: 'APP ID',
    moduleId: 'App ID',
    credentials: '凭证管理',
    scope: '权限',
    events: '事件与回调',
    security: '安全设置',
    products: '订阅产品',
    accountSettings: '账号设置',
  },
  appStatus: {
    development: '开发中',
    published: '已发布',
    offline: '已下线',
  },
  workbench: {
    title: '工作台',
    subtitle: '创建并管理你的开放平台应用',
    createApp: '创建应用',
    createTitle: '创建应用',
    createClose: '关闭',
    createAppIdLabel: 'App ID',
    createAppIdPlaceholder: '以小写字母开头，2–32 位，仅小写字母、数字、短横线',
    createAppIdHint: '创建后不可修改。请写入主包 manifest 的 id。',
    createAgreement: '已阅读并同意《开发者协议》',
    createSubmit: '创建',
    createSuccess: '应用已创建',
    createFailed: '创建失败，请稍后重试',
    nameLabel: '应用名称',
    namePlaceholder: '请输入应用名称',
    descLabel: '应用描述',
    descPlaceholder: '简单描述应用用途',
    roleTitle: '开发者身份',
    developerId: '开发者编号：',
    accountSettings: '账号设置',
    activityTitle: '最近动态',
    viewAll: '查看全部',
    activityEmpty: '暂无动态',
    activityLoadFailed: '动态加载失败',
    activityToday: '今天 {{time}}',
    activityYesterday: '昨天 {{time}}',
    activityDrawerTitle: '全部动态',
    searchPlaceholder: '搜索应用名称',
    filterAll: '全部',
    filterPending: '待上线',
    filterPublished: '已上线',
    collaboration: '协作',
    version: '版本：',
    owner: '所有者：',
    me: '我',
    updatedAt: '最近编辑：{{time}}',
    distributionSpace: '空间自建',
    distributionPublic: '全部空间可用',
    statusInReview: '审核中',
    statusPending: '待上线',
    statusPublished: '已上线',
    statusDeveloping: '草稿',
    statusRejected: '已拒绝',
    statusDelisted: '已下架',
    statusDisabled: '已停用',
    statusArchived: '已下线',
    emptyApps: '还没有应用',
    loadFailed: '应用列表加载失败',
    guideTitle: '欢迎使用 HiBro 开发者控制台',
    guideSubtitle: '按以下步骤发布你的第一个应用',
    guideStep1Title: '创建应用',
    guideStep1Desc:
      '上传主包（.tgz），系统自动解析应用名称与图标，并分配应用 ID',
    guideStep2Title: '完善展示信息 & 提交版本',
    guideStep2Desc: '填写展示信息，按需上传运行平台包，提交审核',
    guideStep3Title: '提交审核',
    guideStep3Desc: '审核通过后自动上线',
    guideCta: '立即创建第一个应用',
    paginationPrev: '上一页',
    paginationNext: '下一页',
    paginationPage: '第 {{page}} 页',
  },
  versions: {
    title: '所有版本',
    create: '新建版本',
    saveSuccess: '保存成功',
    submitSuccess: '版本已提交审核',
    submitScheduled: '已通过审核，将按定时上线',
    submitReleased: '版本已上线',
    issuedCredentialsTitle: '应用凭证已生成',
    issuedCredentialsBody: 'App Secret 只展示这一次，请立即复制保存。',
    scheduleUpdated: '上线时间已更新',
    empty: '暂无版本，点击「新建版本」开始发布流程',
    emptyGuide: '还没有版本，点击「+ 新建版本」上传第一个主包',
    version: '版本号',
    platforms: '支持平台',
    status: '版本状态',
    onlineTime: '上架时间',
    lastUpdated: '最近操作时间',
    operator: '操作人',
    changelog: '更新日志',
    actions: '操作',
    filterAll: '全部',
    filterStatusAll: '全部状态',
    rollingBack: '回滚中…',
    backToList: '返回所有版本',
    stubUploadTitle: '上传安装包',
    stubUploadDesc: '上传与解析流程将在下一屏实现，当前为占位页。',
    stubDetailTitle: '版本详情',
    stubDetailDesc: 'v{{version}} 详情表单将在下一屏实现。',
    stubDetailMissing: '未找到该版本。',
    status_developing: '草稿',
    status_reviewing: '审核中',
    status_rejected: '已拒绝',
    status_scheduled: '待上线',
    status_released: '已上线',
    status_delisted: '已下架',
    status_disabled: '已停用',
    status_archived: '已下线',
    status_rolling_back: '回滚中',
    action_delete: '删除',
    action_withdraw: '撤回审核',
    action_cancelSchedule: '取消定时',
    action_releaseNow: '立即上线',
    action_delist: '下架',
    action_disable: '停用',
    action_relist: '重新上架',
    action_enable: '启用',
    action_rollback: '回滚',
    confirm_delete_title: '删除 v{{version}}？',
    confirm_delete_body: '删除后不可恢复，仅草稿 / 已拒绝版本可删除。',
    confirm_delete_ok: '确认删除',
    confirm_withdraw_title: '撤回审核？',
    confirm_withdraw_body: '撤回后版本将回到草稿，可继续编辑后重新提交。',
    confirm_withdraw_ok: '确认撤回',
    confirm_cancelSchedule_title: '取消定时上线？',
    confirm_cancelSchedule_body:
      '取消后保留审核结论，版本变为已下线，之后可随时立即上线或重新设置定时。',
    confirm_cancelSchedule_ok: '确认取消',
    confirm_releaseNow_title: '立即上线 v{{version}}？',
    confirm_releaseNow_body: '确认后该版本将立即对用户可见。',
    confirm_releaseNow_ok: '确认上线',
    confirm_delist_title: '下架 v{{version}}？',
    confirm_delist_body:
      '将下架应用当前线上版本 v{{version}}（各端一并下线），新用户无法安装。已安装用户可继续正常使用，但不会收到后续版本更新。下架后应用没有线上版本。',
    confirm_delist_ok: '确认下架',
    confirm_disable_title: '停用 v{{version}}？',
    confirm_disable_body:
      '将停用 v{{version}}（各端一并停用），所有用户（含已安装用户）将无法打开或使用。客户端数据不会删除，启用后可立即恢复使用。',
    confirm_disable_ok: '确认停用',
    confirm_relist_title: '重新上架 v{{version}}？',
    confirm_relist_body: '上架后，用户可在应用列表重新安装此应用。',
    confirm_relist_ok: '确认上架',
    confirm_enable_title: '启用 v{{version}}？',
    confirm_enable_body: '启用后，所有用户可重新使用此应用，无需重新审核。',
    confirm_enable_ok: '确认启用',
    confirm_rollback_title: '确认回滚至 v{{version}}？',
    confirm_rollback_body:
      '将整版切回 v{{version}}，用户将使用该版本的安装包与展示信息。建议在低峰时段执行。',
    confirm_rollback_ok: '确认回滚',
    replacesOnline: '当前线上版本 v{{version}} 将下线。',
    actionSuccess: '操作成功',
    reusedFrom: '沿用 v{{version}}',
  },
  versionForm: {
    createTitle: '新建版本',
    uploadTitle: '上传安装包',
    uploadCreateAppTitle: '创建应用',
    backToUpload: '上一步',
    developerAgreement: '已阅读并同意《开发者协议》',
    mainPackage: '主包',
    platformBuilds: '各运行平台安装包',
    releaseNotes: '更新日志',
    appFixedInfo: '应用固定信息',
    displayInfo: '展示信息',
    permissions: '权限',
    events: '事件',
    releaseSchedule: '上线时间',
    submitReview: '提交审核',
    deleteVersion: '删除版本',
    saveVersion: '保存',
    rollbackToThis: '回滚到此版本',
    rejectedTitle: '审核拒绝',
    rejectedNoReason: '审核方未提供具体原因，请联系管理员',
    // 主包
    dropMainPackage: '将 .tgz 文件拖拽到此处',
    mainPackageHint: '（支持 .tgz 格式，最大 1 GB）',
    unsupportedPackageFormat: '不支持该文件格式，仅支持 .tgz',
    reupload: '重新上传',
    selectAnother: '重新选择文件',
    retry: '重试',
    parsing: '解析中，请稍候…',
    parseFailed: '解析失败，请上传正确的安装包',
    uploadFailed: '上传失败，请重试',
    appName: '应用名称',
    appId: '应用 ID',
    moduleId: 'App ID',
    versionCode: '版本号',
    // 平台构建
    platformBuildsHint: '选择本次要发布的运行平台并上传安装包：',
    platformBuildsSubHint:
      '未勾选的平台若有历史包将自动沿用；否则本版本将不包含该运行平台。',
    platformBuildsFirstHint: '请上传全部运行平台安装包：',
    platformBuildsFirstSubHint:
      '首版须为每个声明的运行平台上传安装包，无法沿用历史包。',
    dropPlatformPackage: '将 .tgz 文件拖拽到此处',
    platformPackageHint: '（支持 .tgz 格式，最大 1 GB）',
    reuseHistorical: '未勾选，将沿用历史包 v{{version}}',
    reuseHistoricalInline: '（沿用历史包 v{{version}}）',
    noHistorical: '无历史包，本版本将不包含此运行平台',
    // 更新日志
    changelogPlaceholder: '描述本次更新的内容，将展示在应用详情更新历史中',
    changelogPlatformsHint:
      '本次更新平台：{{updated}}；沿用历史包：{{reused}}。更新日志请描述本次更新平台的变化。',
    multiLangTitle: '更新日志文本',
    releaseNotesTextarea: '更新日志文本',
    textPlaceholder: 'Text...',
    confirmContent: '确认内容',
    multiLangHint: '客户端按用户语言展示对应更新日志；该语种为空则展示默认语言。',
    defaultChangelog: '默认更新日志（{{lang}}）',
    langPlaceholder: '请输入{{lang}}',
    // 应用固定信息
    distributionMethod: '分发方式',
    fixedInfoLocked: '分发方式在首版审核通过后不可修改',
    distSpacePrivate: '空间自建',
    distPublic: '全部空间可用',
    ownerWorkspace: '所属空间',
    eligibleMembers: '可使用成员',
    allMembers: '全员',
    specifiedMembers: '指定成员',
    addEligible: '添加',
    listingCategory: '上架空间类别',
    catWorkspace: '工作空间',
    catPersonal: '个人空间',
    // 展示信息
    supportedLanguages: '支持语言',
    langsAdded: '已添加',
    langsAvailable: '可选语言',
    addLanguage: '添加语言',
    searchLanguage: '搜索语言…',
    defaultTag: '(默认)',
    setDefault: '设为默认',
    setDefaultToast: '已将 {{lang}} 设为默认语言。未适配语言的用户将看到该版内容',
    appCategory: '应用分类',
    categoryPlaceholder: '最多选择 2 个分类',
    appTags: '应用标签',
    selectAppTags: '选择应用标签',
    tagsPlaceholder: 'Text...',
    tagsFull: '已达上限（{{max}}/{{max}}）',
    tagsCount: '已选 {{count}} / {{max}}',
    oneSentence: '一句话介绍',
    oneSentencePlaceholder: '用一句话描述你的应用',
    description: '详细描述',
    descriptionPlaceholder: '详细介绍应用功能与使用场景',
    pcScreenshots: 'PC 截图（Windows/macOS 共用）',
    pcRatioHint: '横屏 16:9，单张 ≤ 5 MB，每语言 1–6 张',
    mobileScreenshots: '移动端截图（iOS/Android 共用）',
    mobileRatioHint: '竖屏 9:16，单张 ≤ 5 MB，每语言 1–6 张',
    screenshotTooLarge: '单张截图不得超过 5 MB',
    ratioPc: '请上传横屏 16:9 截图',
    ratioMobile: '请上传竖屏 9:16 截图',
    website: '官网 URL',
    privacyUrl: '隐私政策 URL',
    termsUrl: '服务条款 URL',
    supportAccount: '联系客服账号',
    supportAccountEmpty: '未找到该用户',
    supportAccountSpace: '工作空间：{{name}}',
    // 权限
    permHint: '本次权限与上一版本一致，如需调整请前往',
    permNoChange: '与上一版本相比权限无变化。',
    permPending: '{{scope}} 等 {{count}} 个权限审核中，将不包含在本次版本',
    permRejected: '{{count}} 个权限审核被拒绝，相关功能将不可用。',
    goScope: '前往权限管理',
    goScopeReapply: '前往权限管理重新申请',
    permManageHint: '如需增减权限，请前往',
    permManage: '权限管理',
    permApp: '应用权限',
    permUser: '用户身份权限',
    permUserConsent: '发布后须用户同意授权',
    permSameAsPrev: '与上一版本相比无变化。',
    permAddedGroup: '新增权限（{{count}}）：',
    permRemovedGroup: '删除权限（{{count}}）：',
    permUnchangedGroup: '未调整权限（{{count}}）：',
    permViewAll: '查看全部',
    permCollapse: '收起',
    permApproved: '已通过',
    changeDetails: '变更明细',
    permChanges: '权限变更：',
    scopeAdded: '新增',
    scopeRemoved: '移除',
    // 事件
    eventApp: '应用身份事件',
    eventUser: '用户身份事件',
    eventAddedGroup: '新增事件（{{count}}）：',
    eventRemovedGroup: '删除事件（{{count}}）：',
    eventUnchangedGroup: '未调整事件（{{count}}）：',
    // 上线时间
    releaseImmediate: '审核通过后立即上线',
    releaseScheduled: '定时上线',
    schedulePlaceholder: '选择日期和时间（最早为 1 小时后）',
    willReleaseAt: '将于 {{time}} 自动上线',
    modifyTime: '修改时间',
    // 未保存
    unsavedTitle: '你有未保存的修改',
    unsavedBody: '离开页面后修改将丢失，是否先保存？',
    dontSave: '不保存',
    saveChanges: '保存',
    // 校验错误
    errMainPackage: '请先上传主包并完成解析',
    errVersionCode: '版本号需大于已上线过的最高版本 {{max}}',
    errNoPlatformPackage: '请至少上传一个本次更新的平台包',
    errFirstPlatformPackages: '首版须上传全部运行平台安装包：{{platforms}}',
    errMissingPlatformPackage: '{{platforms}} 没有可沿用的历史包，请上传',
    errUploading: '安装包上传中，请等待上传完成后再提交',
    errChangelog: '请至少填写一种语言的更新日志',
    errListingCategory: '请选择上架空间类别',
    errOwnerSpace: '请选择所属空间',
    errDescription: '请填写应用详细描述（英语）',
    errUrl: '请输入以 https:// 开头的有效 URL',
    errScheduleTime: '定时上线时间需至少晚于当前时间 1 小时',
    errReviewing: '当前已有版本在审核中，请等待结果或撤回后再提交',
    errScheduled: '当前已有版本等待上线，请在其上线后再提交',
    closeWhileUploadingTitle: '安装包正在上传中',
    closeWhileUploadingContent: '关闭后上传将中断，已上传的进度不会保留，是否继续？',
    dropUploadsContent:
      '开始新的上传将中断当前上传，已上传的进度不会保留，是否继续？',
    closeWhileUploadingOk: '中断并关闭',
    uploadFinishedBeforeClose: '安装包已上传完成，可以继续配置',
  },
  uploadPanel: {
    uploading: '上传中...',
    parsing: '解析中...',
    allSuccess: '上传成功',
    partiallyFailed: '部分上传失败',
    configure: '去配置',
    continueConfigure: '继续配置',
    waiting: '等待上传…',
    collapsed: '上传中（{{count}}）· {{percent}}%',
    remaining: '约剩余 {{time}}',
    remainingSoon: '即将完成',
    remainingSec: '{{s}} 秒',
    remainingMin: '{{m}} 分',
    remainingMinSec: '{{m}} 分 {{s}} 秒',
    remainingHour: '{{h}} 小时',
    remainingHourMin: '{{h}} 小时 {{m}} 分',
  },
  credentials: {
    title: '应用凭证',
    appId: 'App ID',
    moduleId: 'App ID',
    appSecret: 'App Secret',
    appName: '应用名称',
    appNameHint: '展示在工作台与应用详情侧栏，保存后立即生效',
    appIcon: '应用图标',
    appIconHint: '支持 PNG / JPG / GIF，不超过 2 MB',
    changeIcon: '更换',
    nameRequired: '请填写应用名称',
    nameTooLong: '应用名称不能超过 128 个字符',
    iconType: '请上传 PNG / JPG / GIF 格式的图片',
    iconSize: '图片不能超过 2 MB',
    profileSaved: '应用信息已保存',
    appIdHint: '创建应用时由平台分配，绑定后不可修改',
    moduleIdHint: '写入主包 manifest 的 id，创建后不可修改',
    appSecretHint: '默认脱敏展示；显示明文需确认，30 秒后自动隐藏',
    resetNow: '重置',
    resetTitle: '确定要重置 App Secret 吗？',
    confirmReset: '确认重置',
    resetHours: '{{count}} 小时',
    rotate: '安全轮换',
    revealConfirm: 'AppSecret 属于敏感信息，请勿泄露。确认显示明文吗？',
    resetConfirm:
      '重置后旧 App Secret 将立即失效，所有正在进行的 API 调用都会中断。仅在凭证泄露等紧急情况下使用。建议优先使用「安全轮换」。',
    copiedAppId: 'App ID 已复制',
    copiedModuleId: 'App ID 已复制',
    copiedSecret: 'App Secret 已复制',
    resetDone: 'App Secret 已重置，请及时更新调用代码',
    rotating: '轮换进行中',
    rotateHint: '过渡期内新旧 Secret 同时有效，不中断服务',
    error: {
      '32201': '应用 ID 不能为空',
      '32313': '无权访问该应用',
      '32314': '应用不存在',
      secretNotReady: '尚未生成 App Secret，请先上架或重置',
      '32300': '服务暂不可用，请稍后重试',
      '32312': '内部错误，请稍后重试',
      fallback: '查询失败，请稍后重试',
    },
  },
  scope: {
    title: '权限与 Scope',
    desc: '遵循最小权限原则，按需申请所需权限',
    apply: '申请权限',
    requestAccess: '开通权限',
    requestTitle: '开通权限',
    name: '权限名称',
    scope: 'Scope',
    category: '分类',
    categoryAll: '全部',
    identityType: '权限类型',
    identity_app: '应用身份',
    identity_user: '用户身份',
    identityTab_app: '应用身份权限',
    identityTab_user: '用户身份权限',
    sensitivity: '敏感等级',
    actions: '操作',
    relatedApis: '关联 API/事件',
    relatedApisColumn: '关联 API/事件',
    searchPlaceholder: '按名称搜索',
    filterPermission: '权限',
    filterAll: '全部',
    filterReviewYes: '需审核',
    filterReviewNo: '免审',
    empty: '暂无已开通权限',
    hoverAccessToken: '调用凭证',
    hoverRequiresReview: '是否需要审核',
    hoverAutoApproved: '免审权限',
    hoverDescription: '权限说明',
    token_app: 'tenant_access_token',
    token_user: 'user_access_token',
    catalogEmpty: '无匹配权限',
    alreadyOpen: '已开通',
    alreadyOpenTag: '已开通',
    approvalType: '是否需审核',
    approvalHint: '所有权限均为免审，申请权限后立即开通',
    noReview: '免审',
    reviewYes: '需审核',
    selectedLabel: '已选：',
    cancelSelection: '取消选择',
    requestSelected:
      '已选：应用身份权限 ({{app}}) 用户身份权限 ({{user}})',
    cat_userInfo: '用户信息',
    cat_messages: '消息',
    cat_contacts: '通讯录',
    cat_tasks: '任务',
    cat_ai: 'AI 能力',
    cat_files: '文件',
    cat_calendar: '日历',
    batchClose: '批量关闭',
    selectedCount: '已开通：{{count}}',
    close: '关闭',
    withdraw: '撤回',
    withdrawTitle: '确认撤回申请',
    withdrawContent: '确认撤销「{{scopeId}}」的申请吗？',
    withdrawSuccess: '已撤回申请',
    reapply: '重新申请',
    delete: '删除',
    deleteTitle: '删除「{{name}}」？',
    deleteContent1: '删除后该权限申请记录将被彻底移除。',
    deleteContent2: '如需重新使用，可在「开通权限」弹窗中重新申请。',
    deleteConfirmOk: '确认删除',
    deleteSuccess: '已删除「{{name}}」',
    closeTitle: '确认关闭权限',
    closeContent:
      '确认关闭「{{scopeId}}」权限吗？关闭后将不纳入下次版本，版本发布后相关 API 将不可用。',
    batchCloseTitle: '确认批量关闭以下 {{count}} 个权限？',
    batchCloseContent: '关闭后将不纳入下次版本，版本发布后相关 API 将不可用：',
    openSuccess: '权限已开通，将纳入下次版本，发布后才可调用',
    openSuccessUser:
      '权限已开通，将纳入下次版本，发布后才可调用；用户身份权限还须用户同意',
    closeSuccess: '权限已关闭，将不纳入下次版本',
    batchCloseSuccess: '已关闭 {{count}} 个权限，将不纳入下次版本',
    infoLead: 'Scope 控制应用可调用的 API 与可访问的数据范围。',
    info_release_title: '随版本生效',
    info_release_desc: '开通和关闭都须纳入下次版本，发布后才可调用',
    level_normal: '常规',
    level_elevated: '较高',
    level_sensitive: '敏感',
    loadFailed: '权限加载失败',
    openFailed: '开通失败，请稍后重试',
    closeFailed: '关闭失败，请稍后重试',
    batchClosePartial: '{{succeeded}} 个权限关闭成功，{{failed}} 个失败，请稍后重试失败项',
    batchCloseAllFailed: '关闭失败，请稍后重试',
    withdrawUnavailable: '本期不能撤销申请',
    deleteUnavailable: '本期不能删除申请记录',
    paginationPrev: '上一页',
    paginationNext: '下一页',
    paginationPage: '第 {{page}} / {{total}} 页',
    // legacy keys retained for safety
    level: '敏感级别',
    status: '审核状态',
    status_pending: '待审核',
    status_approved: '已开通',
    status_rejected: '已拒绝',
    level_basic: '基础',
    level_org: '组织',
  },
  events: {
    title: '事件与回调',
    desc: '勾选需订阅的事件类型，未勾选的事件不下发',
    sendTest: '发送测试事件',
    subscribed: '已订阅',
    unsubscribed: '未订阅',
    event: '事件类型',
    trigger: '触发时机',
    tabConfig: '事件配置',
    tabEncryption: '加密策略',
    subscriptionMethod: '订阅方式',
    webhookUrl: 'Webhook URL',
    webhookHint: '填写开发者服务器的公网请求地址，平台将向该地址推送事件',
    urlNotConfigured: '订阅地址未配置',
    deliveryPersistent: '通过长连接接收事件',
    deliveryWebhook: '将事件发送至开发者服务器',
    urlPlaceholder: '填写 HTTP/HTTPS URL',
    urlInvalid: '请输入合法的 HTTP/HTTPS 地址',
    goEncryption: '前往加密策略',
    saved: '保存成功',
    saveFailed: '保存失败，请稍后重试',
    challengeFailed: '请求地址校验失败，请检查服务器是否可访问并正确响应 Challenge',
    addedTitle: '已添加事件',
    addEvents: '添加事件',
    eventName: '事件名称',
    eventType:"订阅类型",
    appIdentity:"应用身份",
    subscribeType: '订阅类型',
    subscribeTenant: '应用身份',
    subscribeUser: '用户身份',
    actions: '操作',
    deleteEvent: '删除事件',
    batchDelete: '批量删除',
    deleted: '删除成功',
    deleteFailed: '删除失败，请稍后重试',
    added: '添加成功',
    addFailed: '添加失败，请稍后重试',
    versionRequired: '当前没有可编辑的草稿版本',
    addDrawerTitle: '添加事件',
    searchPlaceholder: '搜索事件名称或 Code',
    searchEmpty: '未找到相关事件，请尝试其它关键词',
    loadFailed: '事件目录加载失败，请稍后重试',
    settingLoadFailed: '事件配置加载失败，请稍后重试',
    listLoadFailed: '已添加事件加载失败，请稍后重试',
    tenantTab: '应用身份订阅',
    userTab: '用户身份订阅',
    tenantHint: '通过 tenant_access_token 订阅事件，将收到该应用自身可获取的事件通知',
    userHint: '通过 user_access_token 订阅事件，将收到登录用户可获取的事件通知',
    selectedCount: '已选择事件：<count>{{count}}</count>',
    encryptionDesc:
      '对事件或回调的请求内容加密，并校验请求来源。当你选择通过将<events>事件</events>或<callbacks>回调</callbacks>发送至开发者服务器进行订阅时生效。',
    encryptKey: 'Encrypt Key',
    encryptInactive: '未开启，请点击「重置」自动生成，或点击「编辑」自定义。',
    verifyToken: 'Verification Token',
    resetEncryptTitle: '确定要重置 Encrypt Key 吗？',
    resetEncryptConfirm:
      '重置后，旧的 Encrypt Key 将立即失效，可能导致服务器解密失败。请确认已准备好同步更新服务器配置。',
    resetTokenTitle: '确定要重置 Verification Token 吗？',
    resetTokenConfirm:
      '重置后，旧的 Verification Token 将立即失效，可能导致服务器校验失败。请确认已准备好同步更新服务器配置。',
    confirmReset: '确认重置',
    encryptResetDone: 'Encrypt Key 已重置',
    tokenResetDone: 'Verification Token 已重置',
    resetFailed: '重置失败，请稍后重试',
    tokenCopied: 'Verification Token 已复制',
    catContact: '通讯录',
    catOrg: '组织架构',
    catMessage: '消息与群组',
    catCalendar: '日历',
    catDocs: '云文档',
    catRoom: '会议室',
    catFile: '云盘',
  },
  security: {
    title: '安全设置',
    banner: '版本发布后，当前修改方可生效',
    viewVersion: '创建版本',
    tabRedirect: '重定向 URL',
    tabIp: 'IP 白名单',
    tabH5: 'H5 可信域名',
    redirectTitle: '重定向 URL',
    redirectDesc:
      '添加重定向 URL 作为免登授权码跳转地址，其他重定向 URL 将无法获取免登授权码。',
    ipTitle: 'IP 白名单',
    ipDesc:
      '开启 IP 白名单后，仅白名单中的来源请求可以正常调用开放平台 API，不在白名单中的来源请求会被拒绝。',
    h5Title: 'H5 可信域名',
    h5Desc:
      '仅可信域名内的 H5 可以访问 JSAPI，部分需要鉴权的 JSAPI 必填。',
    urlPlaceholder: '请填写 HTTP/HTTPS URL',
    ipPlaceholder: '请填写有效的 IP',
    add: '添加',
    batchModify: '批量修改',
    colUrl: 'URL',
    colIp: 'IP',
    colDomain: '域名',
    colActions: '操作',
    invalidUrl: '请输入合法的 HTTP/HTTPS URL',
    invalidIp: '请输入合法的公网 IPv4 地址',
    duplicateUrl: '该 URL 已在列表中',
    duplicateIp: '该 IP 已在列表中',
    duplicateDomain: '该域名已在列表中',
    maxReached: '最多添加 {{max}} 条',
    batchHint: '支持输入或粘贴，回车换行，最多可录入 {{max}} 条',
    batchFieldRedirect: '重定向 URL',
    batchFieldIp: 'IP 地址',
    batchFieldH5: '可信域名',
    batchInvalidUrl: 'URL 格式错误',
    batchInvalidIp: 'IP 格式错误',
    batchLineInvalid: '第 {{n}} 行格式不合法',
    batchSaved: '保存成功',
    batchFailed: '保存失败，请稍后重试',
    confirmTitle: '确定修改吗？',
    confirmDeleted: '你在本次修改中删除了以下内容：',
    confirmHint: '确认后，删除的内容线上立即生效。',
    confirmOk: '确定修改',
    deleteConfirm: '确认删除？',
    deleteOk: '确定',
    loadFailed: '加载失败，请刷新',
    addFailed: '添加失败，请稍后重试',
    saveFailed: '保存失败，请稍后重试',
    deleteFailed: '删除失败，请稍后重试',
  },
  developerInfo: {
    title: '开发者信息',
    changeAvatar: '更换头像',
    name: '开发者名称',
    consoleUrl: '开发者管理后台地址',
    developerId: '开发者编号',
    nameRequired: '请填写开发者名称',
    nameTooLong: '开发者名称不能超过 50 个字符',
    urlInvalid: '请填写有效的 HTTPS 链接',
    saved: '保存成功',
    saveFailed: '保存失败，请稍后重试',
    loadFailed: '加载失败，请刷新',
    avatarType: '请上传 JPG / PNG / WebP 格式的图片',
    avatarSize: '图片不能超过 5 MB',
    cropTitle: '裁剪头像',
    back: '返回',
  },
  sdk: {
    title: 'SDK 下载',
    desc: '下载官方 SDK，查看版本更新日志',
    download: '下载',
    version: '版本',
  },
  entry: {
    deniedTitle: '无法进入开发者平台',
    deniedDesc:
      '请从 HiBro 客户端或空间管理后台进入，必须携带 user_id 与 space_id。',
    userId: '用户 ID',
    spaceId: '空间 ID',
  },
  selectPeople: {
    title: '选择人员',
    searchPlaceholder: '搜索部门或成员',
    selected: '已选 {{count}} 人',
    clear: '清空',
    empty: '暂未选择',
    loadFailed: '加载失败，请稍后重试',
  },
  notFound: {
    desc: '页面不存在',
    back: '返回工作台',
  },
  errorBoundary: {
    title: '页面出了点问题',
    desc: '请刷新或返回工作台后再试。',
    retry: '返回工作台',
  },
  login: {
    title: '开发者控制台',
    subtitle: '请登录',
    signIn: '登录',
    exchanging: '正在登录…',
    loading: '加载中…',
    waitingHost: '正在从客户端获取登录态…',
    misconfigured: '未配置 VITE_AUTH_URL',
    stateMismatch: '登录状态校验失败，请重试',
    failed: '登录失败',
    retry: '重试',
    hostAuthFailed: '无法从客户端获取登录态',
    hostAuthFailedHint: '请确认已在 HiBro 客户端登录，或稍后重试。',
  },
  placeholder: {
    building: '该模块正在建设中',
  },
  products: {
    title: '订阅产品',
    create: '新建产品',
    editTitle: '编辑产品',
    colName: '产品',
    colBilling: '计费',
    empty: '暂无订阅产品',
    limitTip: '已达产品上限（10 个），请删除草稿后再新建',
    network: '操作失败，请检查网络后重试',
    forbidden: '权限不足，请联系应用所有者',
    required: '请检查必填项后重试',
    nameEmpty: '产品名称不可为空',
    priceMin: '请输入至少 0.01 的月单价。',
    tierNameEmpty: '档位名称不可为空',
    tierPriceMin: '请输入至少 0.01 的价格。',
    expireMin: '请输入至少 1 的有效期。',
    moduleNameEmpty: '模块名称不可为空',
    name: '产品名称',
    desc: '产品描述',
    status: '状态',
    billing: '计费方式',
    periods: '周期',
    actions: '操作',
    draft: '草稿',
    scheduled: '待上架',
    published: '已发布',
    unlisted: '已下架',
    free: '免费',
    workspace: '按工作空间',
    seat: '按席位',
    usage: '按用量',
    module: '按功能模块',
    dash: '-',
    listAt: '上架于 {{time}} UTC',
    unlistAt: '{{time}} UTC 下架',
    listAtSuffix: '上架',
    unlistAtSuffix: '下架',
    publish: '发布',
    listNow: '立即上架',
    cancelSchedule: '取消定时',
    relist: '重新上架',
    unlist: '下架',
    duplicate: '复制',
    saveDraft: '保存草稿',
    saveVersion: '保存版本',
    submitPublish: '提交并发布',
    save: '保存',
    textPh: '请输入',
    perMonth: '/月',
    perModuleMonth: '/月',
    oneTime: '一次性',
    effectiveHint: '仅对新产生的订阅计划生效，已有订阅计划的生效时间不变。',
    tierIndex: '档位 {{n}}',
    moduleIndex: '模块 {{n}}',
    basic: '基本信息',
    billingConfig: '计费配置',
    periodConfig: '订阅周期',
    listing: '自动上下架',
    namePh: '请输入产品名称',
    descPh: '请输入产品描述',
    freeHint: '免费产品：工作空间可免费使用。',
    freeMarketHint:
      '若应用未配置任何在架产品，客户端将隐藏「产品方案」区块；仅在发布付费产品后才会出现订阅入口。',
    workspacePrice: '每工作空间月单价',
    seatPrice: '每席位月单价',
    perSeatMonth: '/席位/月',
    perSeat: '/席位',
    priceHint:
      '修改价格不影响已付款的计划；新购与续费（含自动续费）按最新价格。',
    modulePriceHint:
      '修改价格不影响已生效及已付款未生效的计划；新购与续费（含自动续费）按最新价格。',
    usagePriceHint: '修改价格不影响已购额度包；再次购买按新价格。',
    effectiveMode: '生效时间模式',
    afterExpiry: '到期后生效',
    immediate: '立即生效',
    scheduledMode: '指定时间生效',
    effectiveAtPh: '选择生效时间（UTC）',
    effectiveAtFuture: '生效时间须晚于当前时间',
    autorenewal: '自动续费提前扣费天数',
    autorenewalFixed: '2 天（平台默认，不可修改）',
    optionalPeriods: '可选周期',
    addPeriod: '添加周期',
    periodHint: '客户端按订阅周期自动计价：1 个月 = 30 天，1 年 = 12 个月。',
    periodExists: '该周期已存在',
    confirmPeriod: '确认',
    unitDay: '天',
    unitMonth: '月',
    unitYear: '年',
    periodDay: '天',
    periodMonth: '个月',
    periodYear: '年',
    cardDay: '{{n}} 天',
    cardDays: '{{n}} 天',
    cardMonth: '{{n}} 个月',
    cardMonths: '{{n}} 个月',
    cardYear: '{{n}} 年',
    cardYears: '{{n}} 年',
    headDay: '{{n}} 天',
    headDays: '{{n}} 天',
    headMonth: '{{n}} 个月',
    headMonths: '{{n}} 个月',
    headYear: '{{n}} 年',
    headYears: '{{n}} 年',
    listMo: '{{n}} 个月',
    listMos: '{{n}} 个月',
    listYr: '{{n}} 年',
    listYrs: '{{n}} 年',
    modulePriceTable: '各模块 × 所选周期价格（只读，分别计算）',
    tiers: '额度包档位',
    addTier: '新增档位',
    tierName: '档位名称',
    tierDesc: '描述',
    tierPrice: '档位价格',
    expire: '有效期',
    expireHint: '购买后计算到期时间；修改不影响已购额度包。',
    keepOneTier: '至少需保留 1 个档位',
    modules: '功能模块',
    moduleCol: '模块',
    addModule: '新增模块',
    moduleName: '模块名称',
    moduleDesc: '描述',
    monthPrice: '月单价',
    keepOneModule: '至少需保留 1 个模块',
    listMode: '上架时间',
    listNowMode: '立即上架',
    listAtMode: '指定时间',
    scheduleAction: '预约上架',
    relistNowAction: '上架',
    confirmCancelBack: '返回',
    nameUnique: '名称不可重复',
    listAtPh: '选择上架时间（UTC）',
    unlistMode: '下架时间',
    unlistNever: '不自动下架',
    unlistAtPh: '选择下架时间（UTC）',
    utc: 'UTC',
    billingLocked: '发布后不可修改',
    needTier: '至少需配置 1 个额度包档位',
    needModule: '至少需配置 1 个模块',
    needPeriod: '请至少配置 1 个订阅周期',
    listAtFuture: '上架时间须晚于当前时间',
    unlistAfterList: '下架时间须晚于上架时间',
    unlistAfterNow: '下架时间须晚于当前时间',
    draftSaved: '草稿已保存',
    publishedOk: '产品已发布，工作空间现在可订阅此产品',
    scheduledOk: '已预约上架，将于 {{time}} UTC 上架',
    listNowOk: '产品已上架',
    cancelOk: '已取消定时上架，产品回到草稿',
    unlistOk: '产品已下架',
    unlistSaved: '已设置，将于 {{time}} UTC 自动下架',
    relistOk: '产品已重新上架',
    duplicated: '已复制为草稿，请修改后发布',
    deleted: '产品已删除',
    savePrice: '已保存。已付计划不受影响；新购与续费将按新价格',
    saveBoth: '已保存。已付计划不受影响；新购与续费将按新价格。其他变更立即生效',
    saveOther: '已保存，变更立即生效',
    confirmPublishTitle: '确认发布该产品？',
    confirmPublishBody: '发布后工作空间可在应用市场发现并订阅该产品。',
    confirmScheduleTitle: '确认预约上架？',
    confirmScheduleBody: '发布后产品进入待上架，将于 {{time}} UTC 自动上架。',
    confirmUnlistLine: '将于 {{time}} UTC 自动下架。',
    confirmListNowTitle: '确认立即上架？',
    confirmListNowBody: '将跳过预约时间，立即在应用市场展示该产品。',
    confirmCancelTitle: '确认取消定时上架？',
    confirmCancelBody: '取消后产品回到草稿，不会自动上架。已填写的配置会保留。',
    confirmCancelOk: '取消定时',
    confirmRelistTitle: '确认重新上架该产品？',
    confirmRelistBody: '上架后该产品将再次出现在应用市场。',
    confirmRelistScheduleTitle: '确认预约重新上架？',
    confirmRelistScheduleBody:
      '将于 {{time}} UTC 自动上架，届时再次出现在应用市场。',
    confirmUnlistTitle: '确认下架该产品？',
    confirmUnlistBody:
      '下架后该产品不再出现在应用市场，已订阅的工作空间仍可继续使用。已设置的自动下架预约将取消。',
    confirmUnlistOk: '确认下架',
    confirmDeleteTitle: '确认删除该产品？',
    confirmDeleteBody: '删除后不可恢复。',
    leaveTitle: '有未保存内容，是否离开？',
    leaveBody: '离开后未保存的修改将丢失。',
    leaveOk: '离开',
    leaveCancel: '继续编辑',
    i18nTitle: '添加其他语种版本',
    i18nHint:
      '查看该字段时，将根据客户端语言设置展示对应语种内容；若对应语种内容为空，则展示默认名称。',
    i18nEn: '英文(默认)',
    i18nZhCN: '简体中文',
    i18nZhTW: '繁體中文',
    i18nVi: '越南语',
    expand: '展开',
  },
  settlements: {
    title: '订阅结算',
    intro: '财务确认后计入可用余额。点提现可转到 HiBro 钱包或其他钱包。',
    firstHint:
      '财务确认结算单后计入可用余额。点提现可转到 HiBro 钱包或其他钱包。',
    withdraw: '提现',
    balance: '可用余额',
    balanceHint: '已确认未提现',
    statements: '结算单',
    empty: '暂无结算单。到达结算日后将生成。',
    emptyFilter: '暂无符合条件的结算单',
    status: '状态',
    billing: '计费方式',
    dateRange: '预计开始结算日期',
    dateStart: '开始日期',
    dateEnd: '结束日期',
    all: '全部',
    pending: '待确认',
    confirmed: '已确认',
    rejected: '已驳回',
    closed: '已关闭',
    workspace: '按工作空间',
    seat: '按席位',
    usage: '按用量',
    module: '按功能模块',
    statementNo: '结算单号',
    orderNo: '订单号',
    appName: '应用',
    productName: '产品名称',
    spec: '规格',
    settlementDate: '预计开始结算日期',
    amount: '开发者实得',
    action: '操作',
    detail: '详情',
    ongoing: '服务未结束',
    ongoingTip: '服务尚未到期，已按规则到达结算日',
    balanceFail: '余额加载失败，请检查网络后重试',
    loadFail: '加载失败，请检查网络后重试',
    insufficient: '可用余额不足',
    withdrawFail: '提现失败，请检查网络后重试',
    noPerm: '没有权限',
    noPermStatement: '没有权限查看结算单',
    noPermOrder: '没有权限查看订单',
    copied: '已复制',
    withdrawOkHibro: '已提现到 HiBro 钱包',
    withdrawOkExt: '已提交提现',
    backToList: '返回订阅结算',
    detailTitle: '结算单详情',
    serviceRange: '服务起止',
    confirmedAt: '确认时间',
    withdrawNote: '出金须提现至钱包',
    wallet: '选择钱包',
    hibro: 'HiBro 钱包',
    external: '其他钱包',
    amountLabel: '提现金额',
    amountPh: '请输入提现金额',
    allBalance: '全部余额',
    available: '可用',
    chain: '链',
    chainPh: '请选择链',
    chainRequired: '请选择链',
    address: '钱包地址',
    addressPh: '请输入钱包地址',
    addressInvalid: '请输入正确的钱包地址',
    overBalance: '不能超过可用余额',
    confirmWithdraw: '确认提现',
    ethereum: '以太坊',
    bnb: 'BNB Chain',
    tron: 'Tron',
  },
}

export default zhCN
